import styled, { css } from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import { StyledOrderDetailIPadPortrait } from 'src/styles/CommonStyles.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const BottomNavigationContainer = styled.div`
    ${({ setsFilterFooter }) => setsFilterFooter && `
        @media only screen and (min-device-width: ${sizes.mediumDevice}px) and (max-device-width: ${sizes.mediumDevice}px) and (min-device-height: ${sizes.smalDevice}px) and (max-device-height: ${sizes.smalDevice}px) and (orientation: landscape) {
            gap: 18px;
        }
        @media only screen and (min-device-width: 1032px) and (max-device-width: 1032px) and (min-device-height: 1376px) and (max-device-height: 1376px) and (orientation: portrait) {
            gap: 20px;
        }
       @media only screen and (min-width: 810px) and (max-width: 1080px) and (orientation: landscape) {
        gap: 18px;
    }
    `}

  @media (min-width: 1025px) {
        left: ${(props) => (props.isFromTemplates || props.selectedTabIdAccount == 'notes') ? '15%' : undefined};
    }    //transform: translateX(-50%);

    min-height: 60px;
    display: flex;
    position: ${(props) => (props.position ? props.position : 'sticky')};
    width: ${(props) => (props.width && props.width.standard ? props.width.standard : props.selectedTabIdAccount == 'notes' || props.isFromTemplates ? '70%' : '100%')};
    bottom: ${(props) =>
        props.isFromTemplates ? '4%' : props.selectedTabIdAccount == 'notes' ? '9% !important' : (props.bottom ? (props.ship_to_page ? '0' : props.bottom) : '0')};
    margin: 0;
    right: ${(props) => (props.right ? props.right : '')};
    padding: ${({ padding }) => (padding ? padding : '1.125rem 1rem')};
    background-color: #ffffff;
    justify-content: ${(props) =>
        props.desktopJustifyContent
            ? props.desktopJustifyContent
            : 'space-between'};
    align-items: ${(props) => (props.alignItems ? props.alignItems : 'stretch')};
    box-shadow: ${(props) =>
        props.boxShadow ? props.boxShadow : '0px -3px 6px #00000014'};
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '')};
    opacity: ${(props) => (props.opacity ? props.opacity : '1')};
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : ''};

    & img:not(.loader-gif) {
        height: 22px;
        width: 22px;
    }

    ${({ isIPadPotrait }) =>
        isIPadPotrait &&
        css`
            ${StyledOrderDetailIPadPortrait}
        `};
    ${media.portraitDevice`
          width: ${(props) =>
              props.width.portraitDevice ? props.width.portraitDevice : '100%'};
        justify-content: ${(props) => props.justifyContentCenter && 'center'};
    `}
     ${media.ipadAir`
          width: ${(props) =>
              props.width.portraitDevice ? props.width.portraitDevice : '100% !important'};
           bottom: ${(props) =>
               props.bottom && props.ship_to_page ? '65px' : props.isFromPhysicianDetails ? '1%' : null};
            // position: absolute;
            
    `}

    @media (max-width: 1200px) {
        ${({ isConsignmentBilling, isConsignmentReturn,inventoryWidth }) => 
            ((isConsignmentBilling || isConsignmentReturn) && !inventoryWidth) && `width: 100% !important;`}
    }

     @media (min-width: 1060px) and (max-width: 1080px) and (orientation: landscape) {
        ${({isConsignmentBilling, inventoryWidth }) => 
            (isConsignmentBilling && !inventoryWidth) && `width: 100% !important;`}
    }

    ${media.mediumDevice`
        width: ${({ fromAccountPage, selectedTabIdAccount, isFromTemplates, isReportProcedureDataFooter }) => (
            (selectedTabIdAccount == 'notes' || isFromTemplates) 
                ? '85% !important' 
                : (fromAccountPage || isReportProcedureDataFooter) 
                    ? '100%' 
                    : '100%')};
       left : ${({  selectedTabIdAccount }) => 
        (selectedTabIdAccount == 'notes' && '7.5%')} !important;
       justify-content:  ${({selectedTabIdAccount}) => ( selectedTabIdAccount == 'notes' && 'right')} !important;
        position: ${(  props  ) => 
        ( props?.isFromTemplates && 'fixed')};
        bottom:  ${({ isFromTemplates, selectedTabIdAccount} ) => 
            selectedTabIdAccount == 'notes' ? '45px !important' : (isFromTemplates && '0')}
        `}
       
      

    ${media.smalDevice`
    
        width: ${(props) =>
            props.width.smallDevice ? props.width.smallDevice : '100%'};
            position: ${({ buttonsPosition }) =>
                buttonsPosition ? buttonsPosition : undefined} ;
            justify-content: ${(props) =>
                props.selectedTabIdAccount == 'notes' 
                    ? 'center !important' 
                    : (props.smallDeviceJustifyContent && props.smallDeviceJustifyContent)};
            height: ${(props) => props.height && props.height};
           bottom: ${(props) => props.bottom && props.ship_to_page ? '0px' : null}
            }
    `}
    @media (max-width: 768px) {
    left : ${({  selectedTabIdAccount, isFromTemplates }) => 
        (selectedTabIdAccount == 'notes' || isFromTemplates ? '7.5%' : '')} !important;
    width: ${({ fromAccountPage, selectedTabIdAccount, isFromTemplates }) => 
        (fromAccountPage || selectedTabIdAccount == 'notes' || isFromTemplates ? '85%' :  '100%')} !important;
    margin-bottom:  ${( props) => 
        ( props?.isFromTemplates && '5px')};
    bottom:  ${( props ) => 
        ( props?.isFromPhysicianDetails ? '4%' : null)}
   
    }

    @media screen and (min-width: 830px) and (max-width: 840px) and (orientation: portrait) {
        height: ${(props) => props.height && props.height};
        justify-content: ${(props) =>
            props.smalDeviceJustifyContent && props.smalDeviceJustifyContent};
        position: ${(props) =>
            props.portraitposition && props.portraitposition};
        bottom: ${(props) => props.portraitbottom && props.portraitbottom};
    }
    @media screen and (min-width: 768px) and (max-width: 780px) and (orientation: portrait) {
        position: ${(props) =>
            props.portraitposition && props.portraitposition};
        bottom: ${(props) => props.portraitbottom && props.portraitbottom};
    }
    @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
    width: ${(props) =>
              props.width.portraitDevice ? props.width.portraitDevice : '100%'};
        justify-content: ${(props) => props.iPadPortraitJustifyContent || 'center'};
        bottom: ${(props) => props.isFromPhysicianDetails ? '2%' : '0'};
    }
    @media screen and (min-width: 1180px) and (max-height: 820px) {
        bottom: ${(props) => (props.ship_to_page ? '0px' : null)};
    }
@media (max-width: 1024px) {
        width:  ${(props) => ( props.isFromTemplates && '85%')}; /* Apply width for devices with max-width 1024px */
        left:  ${(props) => ( props.isFromTemplates && '7.5%')}; /* Apply left for devices with max-width 1024px */
    }
    ${media.mobileDevice`
  
        width: ${({ fromAccountPage }) => (fromAccountPage ? '100%' :  '100%')} !important;
        margin-top:-2px;
          left : ${(props) => ( props.isFromTemplates || props.selectedTabIdAccount == 'notes' ? '0% !important' : '')};
        position: ${(props) => (props.mbPosition ? props.mbPosition : 'fixed')};
        bottom: ${(props) =>
        props.isFromTemplates || props.selectedTabIdAccount == 'notes' ? '0' : ''};
        justify-content: ${(props) =>
            props.mobileJustifyContent ? props.mobileJustifyContent : ''};
        z-index:${(props) => (props.zIndex ? props.zIndex : '2000')};   
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '')};     
        padding-bottom:${({ padding, paddingBottom, overridePaddingBottom }) =>
            overridePaddingBottom
                ? overridePaddingBottom
                : paddingBottom ? '18px' : 
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(2*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'}          
    `}
`;



